module.exports = __webpack_public_path__ + "static/scale-model-of-lincoln-children's-museum-in-lincoln-nebraska-c119cb87a26b372e8b84923e1459ce75.png";